var scope_0 = require('C:/Users/Administrator/Documents/GitHub/pl-api-frontend/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/2142411cdc2ccd367bfee1202add843e.js').default;

var scope_1 = require('C:/Users/Administrator/Documents/GitHub/pl-api-frontend/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/30b44ff48cf8d07478404fdc5aa9da81.js').default;

var scope_2 = require('C:/Users/Administrator/Documents/GitHub/pl-api-frontend/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/95d7110a0a9c4de86ebd6a54c69e4546.js').default;

var scope_3 = require('C:/Users/Administrator/Documents/GitHub/pl-api-frontend/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;

export default Object.assign({}, scope_0, scope_1, scope_2, scope_3);